import { ChargebacksQueueFields } from "globalConstants";
import { onlyDigits } from "validators/validation";
const { TransactionsCount, TransactionsCountFrom, TransactionsCountTo } =
	ChargebacksQueueFields;

const transactionsCount = ({ formName = "" }) => ({
	name: TransactionsCount.name,
	type: "numeric-range" as const,
	placeholder: TransactionsCount.displayName,
	nameInputFrom: TransactionsCountFrom.name,
	normalize: onlyDigits,
	normalizeOnBlur: onlyDigits,
	nameInputTo: TransactionsCountTo.name,
	title: "Please Select the Transaction Range",
	formName,
	groupColumns: [
		{
			name: TransactionsCountFrom.name,
			formatLabel: value =>
				`${TransactionsCountFrom.displayName}: ${value}`,
		},
		{
			name: TransactionsCountTo.name,
			formatLabel: value =>
				`${TransactionsCountTo.displayName}: ${value}`,
		},
	],
});

export default transactionsCount;
